<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2 safetyApp">
        <div class="boxShadow setBorderRadius frame-accounts heig-frame-equipment-group userTable">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-default-table 
                        :settings="tableConfig" 
                        :tbody-tr-class="rowClass"
                        :table-items="tableItems" 
                        @load-items="getTableData" 
                        @delete-items="deleteItems" 
                        @new-item="createOrEditItem" 
                        @row-click="createOrEditItem" 
                        :show-grid="showGrid" 
                        @import-items="importCompany"
                        @export="exportItems"
                        ref="gofixTable">
                        <template slot="gofix_table:actions" slot-scope="row" v-if="!row.item.is_safety">
                            <b-form-checkbox disabled></b-form-checkbox>
                        </template>
                        <template slot="gofix_table:show-mold" slot-scope="{gridData, tableSelected, actionStatus}">
                            <div class="pl-15 pr-15">
                                <b-row v-if="actionStatus.showFilter">
                                    <b-col md="1">
                                        <gofix-form-input label="ID" v-model="pages.filter.id.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Name" v-model="pages.filter.name.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Mailing Address" v-model="pages.filter.email.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Mobile" v-model="pages.filter.phone.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Contact Person" v-model="pages.filter.contact_name.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-20 rowOrg">
                                    <b-col :key="index" md="4" v-for="(item, index) in gridData">
                                        <div class="boxOrg" :class="{'bg-gray-e9e': !item.is_safety}">
                                            <div class="title d-flex align-items-baseline">
                                                <div class="custom-control custom-checkbox-grid custom-control-inline ml-0" v-if="item.is_safety">
                                                    <input type="checkbox" :value="item.id" v-model="tableSelected.selected" class="custom-control-input" :id="'customInChk'+item.id">
                                                    <label class="custom-control-label" :for="'customInChk'+item.id"></label>
                                                </div>
                                                <strong class="mr-3 ml-3">{{item.id}}</strong>
                                                <div class='d-table-cell'><strong>{{item.name}}</strong></div>
                                            </div>
                                            <div class="content" @click.stop="createOrEditItem(item)">
                                                <p><label>Company Type</label> {{item.company_type}} </p>
                                                <p><label>Contact Person</label> {{item.contact_name }} </p>
                                                <p><label>Mobile</label> {{item.phone}} </p>
                                                <p><label>Email</label> {{item.email}} </p>
                                                <p><label>Address</label>
                                                    {{ item.display_address}}
                                                </p>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </template>
                        <template slot="gofix_table:after-control-left">
                            <li class="control-item showGrid" key="grid-view">
                                <a class="control-item-link cursor-pointer showGrid" v-bind:class="{'active': showGrid}" @click="toggleList" title="Grid View" v-b-tooltip.hover><i class="fa fa-th"></i></a>
                            </li>
                            <li class="control-item showGrid" key="table-view">
                                <a class="control-item-link cursor-pointer showGrid" v-bind:class="{'active': !showGrid}" @click="toggleList" title="Table view" v-b-tooltip.hover><i class="fa fa-th-list"></i></a>
                            </li>
                        </template>
                        <!-- <template slot="gofix_table:before-control-right">
                            <div class="control">
                                <ul class="list-inline">
                                    <li @click="setCompanyType('')" v-bind:class="{'active': this.companyType.value == 'all_companies' || this.companyType.value == ''}">All Suppliers</li>
                                    <li @click="setCompanyType('supplier')" v-bind:class="{'active': this.companyType.value == 'supplier' }">Supplier</li>
                                </ul>
                            </div>
                        </template> -->
                        <template slot="gofix_table:created_at" slot-scope="row">
                            {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:updated_at" slot-scope="row">
                            {{row.item.updated_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                    </gofix-default-table>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'

export default {
    name: 'organisations',
    components: {},
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_companies']))
        return {
            tableConfig: {
                name: 'safety-app-administrator-subcontractor-listing',
                controls: {
                    create: this.$checkRole(this.$accessModule.safety_app_subcontractor, 'create'),
                    delete: this.$checkRole(this.$accessModule.safety_app_subcontractor, 'delete'),
                    tableImport: false,
                    tableExport: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: [],
            showGrid: false,
            pages: {
                isCMS: '1',
                page: 1,
                limit: 100,
                totalPage: 1,
                filter: JSON.parse(JSON.stringify(filters['companies']))
            },
            allSelected: false,
            selected: [],
            isAction: false,
            titleModal: 'create Company',
            show: 'grid',
            nameTable: 'tableCompany',
        }
    },
    computed: {
        ...mapGetters({
            Loadings: 'AllCompanyController/Loadings',
            companyType: 'AllCompanyController/companyType',
        }),
    },
    created() {},
    watch: {
        "pages.filter.name.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.name.value = val;
        },
        "pages.filter.id.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.id.value = val;
        },
        "pages.filter.email.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.email.value = val;
        },
        "pages.filter.phone.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.phone.value = val;
        },
        "pages.filter.contact_name.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.contact_name.value = val;
        }
    },
    methods: {
        rowClass(item) {
            if (item && !item.is_safety) {
                return 'bg-gray-e9e';
            }
            return null;
        },
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            /*if (this.companyType.value) {
                switch (this.companyType.value) {
                    case 'supplier':
                        tableRequest.filter.is_supplier = { type: 'boolean', value: true };
                        tableRequest.filter.is_client = undefined;
                        tableRequest.filter.is_fm_company = undefined;
                        if(this.ClientContractID && this.ClientContractID.id) {
                            tableRequest.filter.contract_id = { type: "number", value: this.ClientContractID.id, function: "=", with: ['contract'] };
                        }
                        break;
                    default:
                        tableRequest.filter.is_supplier = { type: 'boolean', value: true };
                        tableRequest.filter.is_client = undefined;
                        tableRequest.filter.is_fm_company = undefined;
                        tableRequest.filter.contract_id = undefined;
                }
            }*/

            tableRequest.filter.is_supplier = { type: 'boolean', value: true };            
            tableRequest.filter.is_client = undefined;
            tableRequest.filter.is_fm_company = undefined;
            tableRequest.filter.is_safety = { type: 'boolean', value: true };
            
            await this.$store.dispatch("AllCompanyController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load list of companies", "danger");
                    reject();
                })
        },
        createOrEditItem(item = null) {
            this.$router.push(`${this.$route.path}/${item && item.id ? item.id : 0}`);
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            this.$store.dispatch("AllCompanyController/deleteItems", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'company'))
                })
                .catch(err => {
                    console.error("Got nothing from server. Prompt user to check internet connection and try again")
                });
        },
        searchClient() {
            this.$refs.gofixTable.reloadTableKeepFilter();
        },
        toggleList() {
            this.showGrid = !this.showGrid;
        },
        async importCompany(callback) {
            
            const {file, resolve, reject} = await callback();

            let contractID = 0;

            if ( !this.$refs.gofixTable.tableRequest.filter.is_supplier ) {
                this.$alertNotification('This function is not available yet', 'danger');
                resolve();
                return false;
            }

            if ( this.$refs.gofixTable.tableRequest.filter.contract_id.value ) {
                contractID = this.$refs.gofixTable.tableRequest.filter.contract_id.value;
            }

            await this.$store.dispatch(`OrganizationController/importCompany`, {
                fileImport: file,
                contract_id: contractID,
                is_supplier: this.$refs.gofixTable.tableRequest.filter.is_supplier.value,
            })
            .then(response => {
                let variant = 'success';
                let msg = this.$notificationV2('importing', 'company');
                let result = response.data.data;
                if (result.data && result.data.count && result.data.count.failed) {
                    variant = 'danger';
                    msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                }

                this.$alertNotification(msg, variant);
                resolve();
            })
            .catch(error => {
                reject(error);
            });
        },
        exportItems(tableRequest) {
            let request = JSON.parse(JSON.stringify(tableRequest));
            this.$store.dispatch('OrganizationController/exportOrganizations', request)
                .then(response => {
                    let nameFile = 'Companies.xlsx';
                    if(response.headers["content-disposition"]) {
                        let arrTemp = response.headers["content-disposition"].split("filename=");
                        if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
        /*setCompanyType(company_type) {
            this.companyType.value = company_type;
            this.$refs.gofixTable.reloadTableItems();
        },*/
    }
}
</script>